import type { Faq } from '../types/content'

export const faqs: Faq[] = [
  {
    q: 'How do I receive Swim Instructor Ready?',
    a: 'Immediately after completing your purchase, you receive access to the digital material. There is no physical shipment — everything is provided digitally in PDF format.',
  },
  {
    q: 'Is this for new or experienced swim instructors?',
    a: 'The system can support instructors at different stages. Newer instructors can use the structured lessons and progressions to develop a clearer teaching process. More experienced instructors can use it as an expanded lesson, drill, correction, assessment, and class-management library.',
  },
  {
    q: 'What swimming levels are covered?',
    a: 'The material progresses from beginner water-confidence foundations through breathing, floating, stroke development, mixed-level teaching, endurance, and progressive training.',
  },
  {
    q: 'Does it cover the main swimming strokes?',
    a: 'Yes. The system includes structured teaching material for freestyle, backstroke, breaststroke, and butterfly. It also covers breathing, floating, kicking, body position, class management, endurance, and other important skills.',
  },
  {
    q: 'Is this a lifeguard training product?',
    a: 'No. Swim Instructor Ready is specifically designed for swimming instruction. It focuses on lessons, drills, skill development, teaching cues, corrections, assessments, class management, and swimmer progression.',
  },
  {
    q: 'Are the 120 lessons already prepared?',
    a: 'Yes. The main system contains 120 ready-to-teach swimming lessons divided across six structured volumes.',
  },
  {
    q: 'Do I need to use the lessons in exact order?',
    a: 'Not necessarily. You can follow the progression when appropriate, or select lessons and resources according to the swimmer’s current needs and abilities.',
  },
  {
    q: 'Can I use it for private lessons?',
    a: 'Yes. Many of the concepts, drills, progressions, and assessment tools can be used in private and small-group lessons.',
  },
  {
    q: 'What about mixed-level classes?',
    a: 'Volume 5 is specifically dedicated to Mixed-Level Groups & Class Management and includes strategies and lesson structures for working with swimmers at different ability levels.',
  },
  {
    q: 'What if I have limited equipment?',
    a: 'Bonus 5 includes lessons and adaptations designed specifically for limited-equipment, limited-space, small-group, and unexpected teaching situations.',
  },
  {
    q: 'Can I edit the material?',
    a: 'The product is delivered as ready-to-use PDF material and is not sold as editable source files.',
  },
  {
    q: 'What if it is not right for me?',
    a: 'Your purchase is covered by the 7-day money-back guarantee.',
  },
]
